import { createApi } from "@reduxjs/toolkit/query/react";

import { API_VALIDATOR_KEYS } from "@/constants/customer-portal/general.constant";
import { T_Project } from "@/interfaces/customer-portal/projects.interface";
import { ClaimsInvoiceItem } from "@/interfaces/invoicing.interface";
import { Docket } from "@/interfaces/workdocket.interface";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

// Project APIS
export const C_ProjectApi = createApi({
  reducerPath: "C_ProjectApi",
  baseQuery: BaseWithAuth(),
  tagTypes: [
    API_VALIDATOR_KEYS.PROJECTS.DOCKET,
    API_VALIDATOR_KEYS.PROJECTS.INVOICE,
    API_VALIDATOR_KEYS.PROJECTS.WASTE_REPORT,
    API_VALIDATOR_KEYS.PROJECTS.PROJECT,
  ],
  endpoints: (builder) => ({
    // get the info for customer
    getProjects: builder.query<
      GeneralResponse<T_Project[]>,
      { filters?: string; status?: string }
    >({
      query: ({ filters, status }) =>
        `customer/${getCustomerId()}/project${status ? `?status=${status}` : ""}${filters ?? ""}`,
      providesTags: [API_VALIDATOR_KEYS.PROJECTS.PROJECT],
    }),
    getProjectsEntity: builder.query<
      Docket[] | ClaimsInvoiceItem[],
      {
        projectId: string;
        entity: string;
      }
    >({
      query: ({ projectId, entity }) =>
        `customer/${getCustomerId()}/project/${projectId}/${entity}`,
      providesTags: [
        API_VALIDATOR_KEYS.PROJECTS.DOCKET,
        API_VALIDATOR_KEYS.PROJECTS.INVOICE,
        API_VALIDATOR_KEYS.PROJECTS.WASTE_REPORT,
      ],
      transformResponse: (
        response: APIResponse<Docket[] | ClaimsInvoiceItem[]>,
      ) => {
        return response.data;
      },
    }),
    updateCustomerTeam: builder.mutation<
      object,
      {
        data: object;
        projectId: string;
      }
    >({
      query: ({ data, projectId }) => ({
        url: `customer/${getCustomerId()}/project/${projectId ?? ""}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [API_VALIDATOR_KEYS.PROJECTS.PROJECT],
    }),
  }),
});

export const {
  useGetProjectsQuery,
  useGetProjectsEntityQuery,
  useLazyGetProjectsEntityQuery,
  useUpdateCustomerTeamMutation,
} = C_ProjectApi;
